import styled, { css } from 'styled-components';

import { DropdownSize } from '../../theme/Form';
import { rem } from '../../utils';
import type { DropdownNextOptionProps } from './DropdownNext.types';

export const StyledDropDownMenu = styled.div<{
  $displayMode?: 'default' | 'grid';
  $fixedHeight?: DropdownSize;
  $fixedWidth?: number;
  $gridColumns?: number;
}>(
  ({ $displayMode, $fixedWidth, $fixedHeight, $gridColumns, theme }) => css`
    display: ${$displayMode === 'grid' ? 'grid' : 'block'};
    width: ${$fixedWidth ? rem($fixedWidth) : 'fit-content'};
    border-radius: ${rem(theme.Border.Radius.Medium)};
    user-select: none;

    ${$displayMode === 'grid' &&
    css`
      grid-template-columns: repeat(${$gridColumns}, 1fr);
      grid-gap: ${rem(theme.Spacing.Size.XSmall)};
      padding: ${rem(theme.Spacing.Size.XXSmall)};
      width: 100%;
      overflow-y: auto;
      max-height: ${rem(302)};
      ${theme.Scrollbar.ThinScrollbar}
    `}

    ${$fixedHeight &&
    css`
      height: ${rem($fixedHeight)};
      overflow-y: auto;
      align-items: flex-start;
      ${theme.Scrollbar.ThinScrollbar}
    `}
  `
);

export const StyledMenuItemWrapper = styled.div<{
  variant: DropdownNextOptionProps['variant'];
  disabled: DropdownNextOptionProps['disabled'];
}>(
  ({ theme, variant, disabled }) => css`
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: ${rem(theme.Spacing.Size.XSmall)};
    background-color: ${variant === 'selected' ? theme.Color.Brand.Lightest : 'transparent'};
    justify-content: space-between;
    padding: ${`${rem(theme.Spacing.Size.XXSmall)}
    ${rem(theme.Spacing.Size.Small)}`};
    border-radius: ${rem(theme.Border.Radius.XSmall)};
    align-items: center;
    cursor: ${disabled ? 'disabled' : 'pointer'};

    &:hover {
      background-color: ${variant === 'default' && theme.Components.Panel.BackgroundHover};
    }
  `
);

export const StyledMenuItemSideWrapper = styled.div`
  align-items: center;
  flex: 0 0 auto;
`;

export const StyledMenuItemCenterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 1 auto;
`;

export const StyledCustomDropdownItemWrapper = styled.div``;

export const StyledDropdownButton = styled.div`
  width: 100%;
`;

export const StyledDropdownTriggerWrapper = styled.div`
  width: 100%;
`;
